export const driveFiles = {
    meetingRecords: "1H-2Pxv2K1gIgOs4cTkCQNbhOEKGHqwN7",
    documents: "1yZR6a5vUJ2SEfQnOSw_6NJzH9hsBe7RA",
    finalDocuments: "16hadfFR4Fd2swSYfeLl1ciJhxdPMIcas",
}